import {DatePicker, DatePickerProps} from "antd";
import React from "react";
import dayjs from "dayjs";

export interface DocumentDateFieldProps {
    minDate?: dayjs.Dayjs;
    maxDate?: dayjs.Dayjs;
    required?: boolean;
    large?:boolean;
    onChange?: (value: string | undefined) => void;
    value?: dayjs.Dayjs | null;
}

export function DocumentDateField(props: DocumentDateFieldProps) {

    const dateFormat = "DD/MM/YYYY"

    const handleOnChange: DatePickerProps['onChange'] = (date, dateString) => {
        if (props.onChange) {
            const value = Array.isArray(dateString) ? dateString[0] : dateString;
            props.onChange(value || undefined);
        }
    }

    return <DatePicker required={props.required} value={props.value} style={props.large ? { width: '200px'} : {}} onChange={handleOnChange} format={dateFormat} minDate={props.minDate} maxDate={props.maxDate}/>
}